<template>
    <a href="#" class="Navbar__mobile" @click.self.prevent="toggleMenu">
        <div class="MobileMenu" v-show="show">
            <div class="MobileMenu__section">
                <div :class="appHeadingClasses" @click.prevent="toggleApps">Apps</div>
                <div :class="appsClasses">
                    <ul class="Utility__list-unstyled">
                        <li class="MobileMenu__section-item MobileMenu__section-item--app"
                            v-for="app in inactiveApps"
                        >
                            <a :href="getUrl(app.url)" :class="appClass(app.class)">{{ app.name }}</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="MobileMenu__section">
                <div :class="'MobileMenu__active-app MobileMenu__active-app--' + activeApp.class" v-if="activeApp">
                    {{ activeApp.name }}
                </div>

                <ul class="Utility__list-unstyled" v-if="activeApp">
                    <li :class="itemClasses(child)"
                        v-for="child in activeApp.children"
                    >
                        <a :href="getUrl(child.url)"
                           v-if="hasChildren(child)"
                           @click.prevent="toggleChild(child)"
                        >
                            {{ child.name }}
                        </a>

                        <a :href="getUrl(child.url)"
                           v-else
                        >
                            {{ child.name }}
                        </a>
                        <ul class="Utility__list-unstyled" v-if="hasChildren(child)" v-show="child.open">
                            <li v-for="item in child.children" class="MobileMenu__section-child">
                                <a :href="getUrl(item.url)">
                                    {{ item.name }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </a>
</template>

<script>
    export default {
        data() {
            return {
                show: false,
                showApps: false,
            }
        },

        props: {
            // appList: {
            //     type: String,
            // },

            activeApp: {
                type: Object,
            },

            inactiveApps: {
                type: [Array, Object],
                required: true,
            }
        },

        mounted() {
            bus.$on('hide-cover-alls', (caller) => {
                if (caller != 'mobile-menu') {
                    this.show = false;
                }
            });
        },

        computed: {
            classes() {
                return {
                    'MobileMenu': true,
                    'MobileMenu--is-open': this.show,
                }
            },

            apps() {
                return JSON.parse(this.appList);
            },

            // activeApp() {
            //     return _.last(_.toArray(this.apps));
            // },
            //
            // inactiveApps() {
            //     return _.reject(this.apps, (app) => {
            //         return app.name == this.activeApp.name;
            //     });
            // },

            appHeadingClasses() {
                return {
                    'MobileMenu__section-heading': true,
                    'MobileMenu__section-heading--open': this.showApps,
                }
            },

            appsClasses() {
                return {
                    'MobileMenu__apps': true,
                    'MobileMenu__apps--open': this.showApps,
                    'MobileMenu__apps--closed': ! this.showApps,
                }
            }
        },

        methods: {
            toggleMenu() {
                if (this.show) {
                    this.show = false;
                    document.querySelector('body').classList.remove('Utility--no-scroll');
                } else {
                    this.show = true;
                    document.querySelector('body').classList.add('Utility--no-scroll');
                    bus.$emit('hide-cover-alls', 'mobile-menu');
                }
            },

            itemClasses(item) {
                return {
                    'MobileMenu__section-item': true,
                    'MobileMenu__section-item--toggle': this.hasChildren(item),
                    'MobileMenu__section-item--is-open': this.hasChildren(item) && item.open,
                }
            },

            toggleApps() {
                this.showApps = ! this.showApps;
            },

            appClass(className) {
                return 'MobileMenu__section-link MobileMenu__section-link--' + className;
            },

            toggleChild(child) {
                child.open = ! child.open;
                this.$forceUpdate();
            },

            hasChildren(item) {
                return _.has(item, 'children');
            },

            getUrl(url) {
                if (_.isArray(url)) {
                    url = url[0];
                }

                return url.replace('*', '');
            }
        },
    }
</script>
